import {
	styled,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { types } from "api";
import { Order } from "helpers/tableComparator";
import React from "react";

const PREFIX = "GroupTableHead";

const classes = {
	root: `${PREFIX}-root`,
	visuallyHidden: `${PREFIX}-visuallyHidden`,
};

const StyledTableHead = styled(TableHead)({
	[`& .${classes.root}`]: {
		width: "100%",
	},
	[`& .${classes.visuallyHidden}`]: {
		border: 0,
		clip: "rect(0 0 0 0)",
		height: 1,
		margin: -1,
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		top: 20,
		width: 1,
	},
});

interface HeadCell {
	id: keyof types.Group;
	label: string;
	numeric: boolean;
}

const headCells: HeadCell[] = [
	{
		id: "name",
		numeric: false,
		label: "Group Name",
	},
	{ id: "students", numeric: false, label: "Students" },
];

export interface GroupTableHeadProps {
	onRequestSort: (
		event: React.MouseEvent<unknown>,
		property: keyof types.Group,
	) => void;
	order: Order;
	orderBy: string;
}

export const GroupTableHead = ({
	order,
	orderBy,
	onRequestSort,
}: GroupTableHeadProps): JSX.Element => {
	const createSortHandler =
		(property: keyof types.Group) => (event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		};

	return (
		<StyledTableHead>
			<TableRow>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
							data-testid="sort-label"
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<span className={classes.visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</span>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
				<TableCell key="action">Action</TableCell>
			</TableRow>
		</StyledTableHead>
	);
};
